import { Button, Drawer } from "antd";
import Icon from "@ant-design/icons";
import { TrolleyIcon } from "../../assets/icons/icons";
import "./ConfirmationModal.scss";

interface TrolleyServiceabilityModalProps {
  open: boolean;
  trolleyId: string;
  status?: string;
  lastScannedLocation?: string;
  mode: "serviceable" | "unserviceable";
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const TrolleyServiceabilityModal = ({
  open,
  trolleyId,
  status,
  lastScannedLocation,
  mode,
  onConfirm,
  onCancel,
  isLoading = false,
}: TrolleyServiceabilityModalProps) => {
  const isServiceable = mode === "serviceable";

  const subtitle = isServiceable
    ? "Select the correct condition based on your inspection before confirming."
    : "Confirm the trolley's condition before marking it as Unserviceable.";

  const confirmLabel = isServiceable
    ? "Mark as Serviceable"
    : "Mark as Unserviceable";

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      className="confirmation-drawer"
      placement="bottom"
      closable={false}
      mask={true}
      height="auto"
      destroyOnClose
    >
      <div className="confirmation-content">
        <h2 className="confirmation-title">Update Trolley Condition</h2>
        <p className="confirmation-subtitle">{subtitle}</p>

        <div className="info-card">
          <div className="info-header">
            <div className="info-row">
              <div className="info-icon">
                <Icon component={TrolleyIcon} />
              </div>
              <div>
                <div className="info-label">Trolley ID</div>
                <div className="info-value">{trolleyId}</div>
              </div>
            </div>
          </div>

          <div className="info-details-grid">
            <div className="info-item">
              <div className="info-label">Status</div>
              <div className="info-value-small">{status || "—"}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Last Scanned Location</div>
              <div className="info-value-small">
                {lastScannedLocation || "N/A"}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <Button
            onClick={onCancel}
            className="cancel-button"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="confirm-button"
            loading={isLoading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default TrolleyServiceabilityModal;


